import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { RemoteFetchInputUsageSummary } from "../../../data/usecases/input-utilization/remote-fetch-input-usage-summary";
import { FetchInputUsageSummary } from "../../../domain/useages/input-utilization/fetch-input-usage-summary";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { InputUsageSummary } from "../../../domain/models/input-utilization/input-usage-summary";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchInputUsageSummaryInterface {
  fetchInputUsageSummary: Function;
  inputUsageSummaryLoading: FetchState;
  inputUsageSummaryFilters: {
    role_id: string;
    input_ids: string[];
    product_type?: string;
  };
  inputUsageSummaryData: InputUsageSummary[];
}

const initialStates = {
  inputUsageSummaryLoading: FetchState.DEFAULT,
  inputUsageSummaryFilters: {
    role_id: "",
    input_ids: [],
  },
  inputUsageSummaryData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchInputUsageSummary: StateCreator<
  FetchInputUsageSummaryInterface
> = (set, get) => ({
  ...initialStates,
  fetchInputUsageSummary: async () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    set(() => ({ inputUsageSummaryLoading: FetchState.LOADING }));
    const remoteFetchInputUsageSummary: FetchInputUsageSummary =
      new RemoteFetchInputUsageSummary(
        `${BASE_URL}${Endpoints.FETCH_INPUT_USAGE_SUMMARY}`,

        axiosHttpClient
      );
    let params = {
      role_id: get().inputUsageSummaryFilters.role_id,
      input_ids: get().inputUsageSummaryFilters.input_ids,
      product_type: get().inputUsageSummaryFilters.product_type,
    };
    let result = await remoteFetchInputUsageSummary.fetch(params);

    if (result) {
      set(() => ({ inputUsageSummaryData: result.summary }));
      set(() => ({ inputUsageSummaryLoading: FetchState.SUCCESS }));
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: "Error Occured While Fetching Input Usage Summary Data",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
